import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SpinnerStyle = styled.div`
  display: inline-block;
  position: relative;
  top: 2px;
  margin-left: 8px;
  width: 14px;
  height: 14px;
  border: 2px solid #b2b2b3;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
